(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-logo-slider"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function() {
      
      if ($(window).width() >= 768) {
          let totalWidth = $('.customLogoHeading').width() + $('.rightMoskot').width();
          $('.customLogoSliderInnerWrap').css('width', 'calc(100% - ' + totalWidth + 'px - ' + 100 + 'px)');
        }
       $('.customLogoSlider').owlCarousel({
         loop:true,
         
         autoWidth:false,
         dots:false,
         nav:false,
         responsive:{
             0:{
                 items:2,
                margin:10
                                              
             },
             600:{
                 items:3,
               margin:10
             },
             768:{
                 items:2,
                margin:40
             },
             989:{
                 items:3,
                 margin:40
             },
             1080:{
                 items:4,
                margin:50
                 
             },
             1500:{
                 items:4
                 
             }
         }
     })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
